import ExcluirRelatorioAjuste from '@/templates/Relatorios/Ajustes/ExcluirRelatorioAjuste'
import RelatorioAjustes from 'pages/RelatorioAjustes'
import React from 'react'
import { RouteObject } from 'react-router-dom'
import { DetalhesRegistro } from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesRegistros'
import DetalhesDescontoDSR from 'templates/Relatorios/DSR/DetalhesDescontoDSR'
import ExcluirRelatorioEspelhoPeriodo from 'templates/Relatorios/EspelhoPeriodo/ExcluirRelatorio'
import NovoRelatorioEspelhoPeriodo from 'templates/Relatorios/EspelhoPeriodo/NovoRelatorio'
import ConfiguracaoValeAlimentacao from 'templates/Relatorios/ValeAlimentacao/atoms/Configuracao'
import BaixarPeriodoModal from 'templates/Relatorios/EspelhoPonto/modals/BaixarPeriodoModal'
import DetalhesValeAlimentacao from 'templates/Relatorios/ValeAlimentacao/atoms/Detalhes'

const AdicionaisNoturno = React.lazy(
    () => import('@/pages/RelatorioAdicionalNoturno'),
)
const EspelhoPonto = React.lazy(() => import('pages/EspelhoPonto'))
const ComprovantePonto = React.lazy(() => import('pages/ComprovantePonto'))
const RelatorioSaldoHoras = React.lazy(
    () => import('pages/RelatorioSaldoHoras'),
)
const RelatorioVencimentoBanco = React.lazy(
    () => import('pages/RelatorioVencimentoBanco'),
)
const RelatorioInconsistencias = React.lazy(
    () => import('pages/RelatorioInconsistencias'),
)
const RelatorioValeAlimentacao = React.lazy(
    () => import('pages/RelatorioValeAlimentacao'),
)
const RelatorioAbsenteismo = React.lazy(
    () => import('pages/RelatorioAbsenteismo'),
)
const RelatorioRegistrosForaCerca = React.lazy(
    () => import('pages/RelatorioRegistrosForaCerca'),
)
const RelatorioAceiteEspelho = React.lazy(
    () => import('pages/RelatorioAceiteEspelho'),
)
const RealtorioRegistrosExcluidos = React.lazy(
    () => import('pages/RelatorioRegistrosExcluidos'),
)
const RelatorioDescontoDSR = React.lazy(
    () => import('pages/RelatorioDescontoDSR'),
)
const RelatorioHorasTrabalhadas = React.lazy(
    () => import('pages/RelatorioHorasTrabalhadas'),
)
const TrocaHorarios = React.lazy(() => import('pages/TrocaTabelaHorarios'))
const HorasSuprimidas = React.lazy(
    () => import('pages/RelatorioHorasSuprimidas'),
)
const RelatorioPontoDiario = React.lazy(
    () => import('pages/RelatorioPontoDiario'),
)
const RelatoriosAjustesImpressos = React.lazy(
    () => import('templates/Relatorios/Ajustes/RelatoriosImpressos'),
)
const HistoricoAceiteEspelhoPonto = React.lazy(
    () => import('@/templates/Relatorios/AceiteEspelho/Historico'),
)
const ItensDashboard = React.lazy(
    () => import('templates/Relatorios/Dashboard'),
)
const RelatorioFaltasAtrasos = React.lazy(
    () => import('@/pages/RelatorioFaltasAtrasos'),
)
const RelatorioEspelhoPeriodo = React.lazy(
    () => import('pages/RelatorioEspelhoPeriodo'),
)
const RelatorioComissoes = React.lazy(
    () => import('@/pages/RelatorioComissoes'),
)

const LogsPage = React.lazy(() => import('pages/Logs'))
const AuditoriaPage = React.lazy(() => import('pages/Auditoria'))

const base = '/relatorios'

export const relatorios: RouteObject = {
    path: base,
    children: [
        {
            path: base + '/ajustes',
            element: <RelatorioAjustes />,
            children: [
                {
                    path: base + '/ajustes/impressos',
                    element: <RelatoriosAjustesImpressos />,
                    index: true,
                    children: [
                        {
                            path: base + '/ajustes/impressos/:hash/excluir',
                            element: <ExcluirRelatorioAjuste />,
                        },
                    ] as any,
                },
            ],
        },
        {
            path: base + '/adicional-noturno',
            element: <AdicionaisNoturno />,
        },
        {
            path: base + '/espelho-ponto',
            element: <EspelhoPonto />,
            children: [
                {
                    path: base + '/espelho-ponto/baixar-periodo',
                    element: <BaixarPeriodoModal />,
                },
            ],
        },
        {
            path: base + '/aceite-espelho',
            element: <RelatorioAceiteEspelho />,
            children: [
                {
                    path: base + '/aceite-espelho/historico',
                    element: <HistoricoAceiteEspelhoPonto />,
                    index: true,
                },
            ],
        },
        {
            path: base + '/saldo-horas',
            element: <RelatorioSaldoHoras />,
        },
        {
            path: base + '/vencimento-banco',
            element: <RelatorioVencimentoBanco />,
        },
        {
            path: base + '/inconsistencias',
            element: <RelatorioInconsistencias />,
        },
        {
            path: base + '/vale-alimentacao',
            element: <RelatorioValeAlimentacao />,
            children: [
                {
                    path: base + '/vale-alimentacao/:funcionarioId',
                    element: <DetalhesValeAlimentacao />,
                },
                {
                    path: base + '/vale-alimentacao/configuracao',
                    element: <ConfiguracaoValeAlimentacao />,
                },
            ],
        },

        {
            path: base + '/comprovante-ponto',
            element: <ComprovantePonto />,
        },

        {
            path: base + '/troca-horario',
            element: <TrocaHorarios />,
        },
        {
            path: base + '/absenteismo',
            element: <RelatorioAbsenteismo />,
        },
        {
            path: base + '/registros-fora-cerca',
            element: <RelatorioRegistrosForaCerca />,
            children: [
                {
                    path: base + '/registros-fora-cerca/:registroId/detalhes',
                    element: <DetalhesRegistro />,
                },
            ],
        },
        {
            path: base + '/registros-excluidos',
            element: <RealtorioRegistrosExcluidos />,
            children: [
                {
                    path: base + '/registros-excluidos/:registroId/detalhes',
                    element: <DetalhesRegistro />,
                },
            ],
        },
        {
            path: base + '/desconto-dsr',
            element: <RelatorioDescontoDSR />,
            children: [
                {
                    path: base + '/desconto-dsr/:id/detalhes',
                    element: <DetalhesDescontoDSR />,
                },
            ],
        },
        {
            path: base + '/horas-trabalhadas',
            element: <RelatorioHorasTrabalhadas />,
        },
        {
            path: base + '/horas-suprimidas',
            element: <HorasSuprimidas />,
        },
        {
            path: base + '/ponto-diario',
            element: <RelatorioPontoDiario />,
        },
        {
            path: base + '/dashboard',
            element: <ItensDashboard />,
        },
        {
            path: base + '/faltas-atrasos',
            element: <RelatorioFaltasAtrasos />,
        },
        {
            path: base + '/espelho-periodo',
            element: <RelatorioEspelhoPeriodo />,
            children: [
                {
                    path: base + '/espelho-periodo/relatorio',
                    element: <NovoRelatorioEspelhoPeriodo />,
                },
                {
                    path: base + '/espelho-periodo/:id/excluir',
                    element: <ExcluirRelatorioEspelhoPeriodo />,
                },
            ],
        },
        {
            path: base + '/comissoes',
            element: <RelatorioComissoes />,
        },
        {
            path: base + '/logs',
            element: <LogsPage />,
        },
        {
            path: base + '/auditoria',
            element: <AuditoriaPage />,
        },
    ],
}
